import { relevantRepresentatives } from '../../utils/localRepresentative/parser';

const removeDuplicates = (arr, prop) => {
    if (prop && typeof prop === 'string') {
        return arr.filter((obj, index, arr) => {
            return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === index;
        });
    } else {
        return arr.filter(function(item, index, arr) {
            return arr.indexOf(item) === index;
        });
    }
};

const getPlaceholder = placeholder => {
    return placeholder === 'Topic'
        ? 'Subject'
        : placeholder === 'Zip'
        ? 'Postal Code'
        : placeholder === 'Phone'
        ? 'Phone Number'
        : placeholder === 'NamePrefix'
        ? 'Prefix'
        : placeholder === 'Street'
        ? 'Street No & Street'
        : placeholder;
};

const sortOrder = [`Street`, `City`, `County`, `Zip`, `Phone`];

export const requiredFormElements = state => {
    const reps = state.localRep.localRepData
        ? relevantRepresentatives(
              state.widget.activeAction.localRepresentativeState,
              state.localRep.localRepData.representative
          )
        : [];

    return removeDuplicates(
        [].concat.apply([], reps.map(rep => rep.requiredFormElements))
    ).map(a => ({
        type: a.type,
        name: a.name,
        index: sortOrder.indexOf(a.name),
        options: a.options,
        defaultOption: 'Choose',
        placeholder: getPlaceholder(a.name)
    }));
};



// WEBPACK FOOTER //
// ./src/components/Email/representatives.js